<div *ngIf="debug" class="container pb-3">
  <div class="row">
    <div class="col-6">
      <app-button [title]="'Load Order'" (clickEvent)="onLoadOrder()" [fullSize]="true"></app-button>
    </div>
    <div class="col-6">
      <app-button [title]="'Save Order'" (clickEvent)="onSaveOrder()" [fullSize]="true"></app-button>
    </div>
  </div>
</div>
<div *ngIf="order" class="ticket-view">
  <h3>{{ title | translate }}</h3>
  <p class="date-header" *ngIf="header && !datesExist">{{ header }}</p>
  <hr class="mw-100" *ngIf="!order.orderLines.length" />
  <div *ngIf="!order.orderLines.length" class="order-lines">
    <p class="text-truncate" title="{{ 'No Articles yet' | translate }}">{{ 'No Articles yet' | translate }}</p>
  </div>
  <div *ngIf="order.orderLines.length" class="order-lines-multi">
    <span *ngFor="let date of dates">
      <p *ngIf="date" class="date-header"><span *ngIf="allowDelete" (click)="deleteLinesByDate(date)" class="delete">
          <fa-icon [icon]="faTrash"></fa-icon>
        </span>{{'Booking-basket-header' | translate: getGroupHeaderParams(date)}}
      </p>
      <hr class="mw-100" />
      <span *ngFor="let orderLine of getOrderLines(date)">
        <p class="text-truncate" title="{{ orderLine.quantity }} x {{ orderLine.name | translate}}">
          <span *ngIf="allowDeleteOrderLine(orderLine) && !date" (click)="deleteOrderLine(orderLine)"><fa-icon [icon]="faTrash"></fa-icon></span>
          <span class="amount">{{ toMoneyStr(orderLine.amount) }}</span>
          {{ orderLine.quantity }} x {{ orderLine.name | translate}}
        </p>
        <p class="text-truncate line-info" *ngIf="orderLine.groupSize" title="{{ orderLine.groupSize }} x {{ orderLine.name | translate}}">
          {{ orderLine.groupSize }} x {{ orderLine.name | translate}}
        </p>
      </span>
    </span>
  </div>
  <hr class="mw-100" />
  <div *ngIf="giftcardAmount > 0 || discountAmount > 0">
    <p class="text-truncate" *ngIf="giftcardAmount > 0">
      {{ paymentGiftMessage | translate }}
      <span class="amount">-{{ toMoneyStr(giftcardAmount) }}</span>
    </p>
    <p class="text-truncate" *ngIf="discountAmount > 0">
      {{ 'Discount' | translate }}
      <span class="amount">-{{ toMoneyStr(discountAmount) }}</span>
    </p>
    <hr class="mw-100" />
  </div>
  <div class="basket-amount">
    <div class="basket-total">{{ 'Sum' | translate }}: {{ toMoneyStr(order.totalAmount - discountAmount -
      giftcardAmount)
      }}</div>
    <div [ngClass]="{'tax-zero-amount': this.order?.totalTax == 0}" class="basket-tax">{{ 'incl VAT' | translate }}: {{
      toMoneyStr(order.totalTax) }}</div>
  </div>
</div>
